import axios from 'axios'

const TicketService = {
  async getTickets (filters) {
    return axios({
      url: axios.defaults.baseURL + 'ticket/get/',
      data: JSON.stringify({ filters: filters }),
      method: 'post'
    })
  },

  async deleteTicket (filters) {
    return axios({
      url: axios.defaults.baseURL + 'ticket/delete/',
      data: JSON.stringify({ filters: filters }),
      method: 'post'
    })
  },

  async askOpenAI (payload) {
    return axios({
      url: axios.defaults.baseURL + 'openai/ask/',
      data: JSON.stringify({ payload: payload }),
      method: 'post'
    })
  },

  async saveToS3 (content, companyId, payload) {
    const data = {
      content: content,
      company_id: companyId,
      payload
    }

    return axios({
      url: axios.defaults.baseURL + 'openai/save/',
      data: JSON.stringify({ data: data }),
      method: 'post'
    })
  },

  async sendEmail (content, companyId, payload) {
    const data = {
      content: content,
      company_id: companyId,
      payload
    }
    return axios({
      url: axios.defaults.baseURL + 'openai/email/',
      data: JSON.stringify({ data: data }),
      method: 'post'
    })
  },

  async downloadPDF (content, companyId, payload) {
    const data = {
      payload,
      content: content,
      company_id: companyId
    }
    return axios({
      url: axios.defaults.baseURL + 'openai/download-pdf/',
      data: JSON.stringify({ data: data }),
      method: 'post',
      responseType: 'blob'
    })
  },

  async downloadReportsPDF (content, companyId, payload) {
    const data = { payload, content, company_id: companyId }
    return axios({
      url: axios.defaults.baseURL + 'openai/download-reports-pdf/',
      data: JSON.stringify({ data }),
      method: 'post',
      responseType: 'blob'
    })
  },

  async update (ticketId, info) {
    const data = {
      id: ticketId,
      info: info
    }
    return axios({
      url: axios.defaults.baseURL + 'ticket/update',
      method: 'POST',
      data: JSON.stringify({ data: data })
    })
  },

  async getTicketStatuses () {
    return axios({
      url: axios.defaults.baseURL + 'ticket/getStatuses',
      method: 'GET'
    })
  },

  async getNotes (ticketid) {
    return axios({
      url: axios.defaults.baseURL + 'ticket/getNotes/' + ticketid,
      method: 'GET'
    })
  },

  async reportingFilters () {
    return axios({
      url: axios.defaults.baseURL + 'ticket/reportingFilters/',
      method: 'GET'
    })
  },

  async breakdown (filters) {
    return axios({
      url: axios.defaults.baseURL + 'ticket/breakdown/',
      data: JSON.stringify({ filters: filters }),
      method: 'POST'
    })
  },

  async detail (filters) {
    return axios({
      url: axios.defaults.baseURL + 'ticket/breakdown/detail',
      data: JSON.stringify({ filters: filters }),
      method: 'POST'
    })
  },

  async export (filters) {
    return axios({
      url: axios.defaults.baseURL + 'ticket/breakdown/export',
      data: JSON.stringify({ filters: filters }),
      method: 'POST'
    })
  }
}

export default TicketService
